export default {
  // Chờ kiểm tra: Nếu Tình trạng hóa đơn trên Inbot là Đang kiểm tra
  Waiting: 0,
  // Cảnh báo: Nếu Tình trạng hóa đơn trên Inbot là Không hợp lệ, Không có bản thể hiển, Bản nháp, Không có XML
  Invalid: 1,
  // Hợp lệ:  Nếu Tình trạng hóa đơn trên Inbot là Hợp lệ
  Valid: 2
};
